import { uuid } from './uuid.ts';

/**
 * Identité d'appareil STABLE (UUID persistant en localStorage), envoyée au serveur
 * via l'en-tête X-Ocerm-User. Elle garde la stabilité des confirmations /action et
 * la paternité technique des notes. Le propriétaire métier d'un contact vient du
 * membre Twenty connecté, pas de cette valeur dev-*.
 *
 * null si localStorage est indisponible : on n'envoie alors PAS d'identité (pas
 * d'attribution) plutôt qu'un faux id partagé qui corromprait l'appartenance.
 */
const CLE = 'ocerm-device-id';
let cache: string | null | undefined;

export function idAppareil(): string | null {
  if (cache !== undefined) return cache;
  try {
    let id = localStorage.getItem(CLE);
    if (!id) {
      id = `dev-${uuid()}`;
      localStorage.setItem(CLE, id);
    }
    cache = id;
  } catch {
    cache = null;
  }
  return cache;
}

/** Vrai si `auteur` (ou ancien propriétaire technique renvoyé par l'API) est CET appareil : la PWA
 *  affiche alors « moi » au lieu de l'identifiant brut. */
export function estMoi(identite: string | null | undefined): boolean {
  return Boolean(identite) && identite === idAppareil();
}
